import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { FIREBASE_AUTH } from '../firebase';
import { AuthService } from './auth.service';

export const publicGuard: CanActivateFn = async () => {
  const auth = inject(FIREBASE_AUTH);
  const user = inject(AuthService).user;
  const router: Router = inject(Router);

  await auth.authStateReady();
  if (!user()) return true;

  router.navigateByUrl('/');
  return false;
};
